module.exports = __webpack_public_path__ + "img/icon-add-circle-small.02240511.svg";